module.exports = __webpack_public_path__ + "static/media/sidebarimhs23.b229f226.png";